import React, { useState, useEffect, useRef } from 'react';
import AiAvatar from '../../../../assets/img/capitaoRocha.jpeg';
import Sidebar from '../sidebar';
import { Button, Form, FormGroup, Modal, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ModalFilters from '../modalFilters';
import ModalAttachment from '../modalAttachment';
import ModalClearData from '../modalClearData';
import ModalFilePreview from '../modalFilePreview';
import AIMessage from '../aiMessage';

const MainContent = () => {
  const [messages, setMessages] = useState([
    { id: 1, text: 'Olá! Como posso te ajudar hoje?', sender: 'assistant' }
  ]);
  const [inputValue, setInputValue] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const [aiModel, setAiModel] = useState('');
  const chatWindowRef = useRef(null);

  const [modelConfigurations, setModelConfigurations] = useState([]); // <-- valor inicial é []
  const [queryType, setQueryType] = useState(null);
  const [availableQueryTypes, setAvailableQueryTypes] = useState([]);

  const now = new Date();
  now.setHours(0, 0, 0, 0); // zera o horário

  const maxDaysFilter = 30;
  // const [startDate, setStartDate] = useState(new Date(now.getFullYear(), now.getMonth() - 1, now.getDate()));
  const [startDate, setStartDate] = useState(
    new Date(now.getFullYear(), now.getMonth(), 1)
  );
  const [endDate, setEndDate] = useState(now);

  const [showConfigModal, setShowConfigModal] = useState(false);

  const [showAttachModal, setShowAttachModal] = useState(false);

  const [frontConfigurations, setFrontConfigurations] = useState([]);

  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const [showFileModal, setShowFileModal] = useState(false);
  const [filePayload, setFilePayload] = useState(null);

  const [loading, setLoading] = useState(false);

  // Carregar configurações da API ao montar
  useEffect(() => {
    if (sessionStorage.getItem('OpenAi_UploadedFileIds')) {
      sessionStorage.removeItem('OpenAi_UploadedFileIds');
    }

    const initializeAssistant = async () => {
      // updateAssistantsKnowledgeBase();
      if (!sessionStorage.getItem("OpenAi_threadId")) {
        setLoading(true);
        await getNewThread(); // Wait for getNewThread to finish
        setLoading(false);
      }

      await getAssistantsQueries(); // This will only run after the await is resolved
    };

    initializeAssistant();
  }, []);
  const updateAssistantsKnowledgeBase = async () => {
    setLoading(true);
    try {
      const response = await fetch(window.ai_api_service + "api/OpenAi/UpdateAssistantsKnowledgeBase/" + window.database_type, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      });

      if (response.status != 200) {
        console.error('Erro ao carregar configurações de assistentes:', response);
      }

    } catch (e) {
      console.error('Erro ao carregar configurações de assistentes:', e);

    } finally {
      setLoading(false);
    }

  }

  // Atualiza opções de consulta ao trocar de modelo
  useEffect(() => {
    if (modelConfigurations.length > 0) {
      const selectedConfig = modelConfigurations.find(config => config.assistantId === aiModel);
      if (selectedConfig) {
        setAvailableQueryTypes(selectedConfig.queries);
        setQueryType(selectedConfig.queries[0]?.id ?? null);
      }
    }
  }, [aiModel, modelConfigurations]);

  // Scroll para o fim do chat
  useEffect(() => {
    if (chatWindowRef.current) {
      chatWindowRef.current.scrollTop = chatWindowRef.current.scrollHeight;
    }
  }, [messages, isTyping]);

  const getNewThread = async () => {
    try {
      const response = await fetch(window.ai_api_service + "api/OpenAi/GetNewThread", {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });

      let data = await response.json();

      sessionStorage.setItem("OpenAi_threadId", data.threadId);

    } catch (error) {
      console.error("Erro ao obter uma nova thread: " + error);
    }
  }

  const getAssistantsQueries = async () => {
    try {
      const response = await fetch(window.ai_api_service + "api/OpenAi/GetAssistantsQueries/" + window.database_type, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });

      const data = await response.json();

      // Adiciona "Sem Consulta" em cada lista de queries

      setModelConfigurations(data);


      // Extrair as configurações do front em um array separado
      const fronts = data.map(({ frontLabel, frontIcon, endpointApi, assistantId }) => ({
        frontLabel,
        frontIcon,
        endpointApi,
        assistantId
      }));

      setFrontConfigurations(fronts);

      // Inicializa com o primeiro grupo
      if (data.length > 0) {
        setAiModel(data[0].assistantId);

        data.map((item) => {
          item.queries.unshift({ id: 0, nomeConsulta: "Selecione uma consulta..." })
        })


        setAvailableQueryTypes(data[0].queries);
        setQueryType(0);

        sendDataToAssistant(data[0].assistantId, data[0].queries)
      }

    } catch (e) {
      console.error('Erro ao carregar configurações de assistentes:', e);
    }
  };

  const handleChangeAiModel = async (aiModel) => {
    // setMessages([
    //   { id: 1, text: 'Olá! Como posso te ajudar hoje?', sender: 'assistant' }
    // ]);
    setStartDate(new Date(now.getFullYear(), now.getMonth(), 1));
    setEndDate(now);
    setAiModel(aiModel);
    sessionStorage.removeItem('OpenAi_UploadedFileIds');
    await getNewThread();
    await sendDataToAssistant(aiModel, null, false);
  }

  const handleConfirmDelete = () => {
    sessionStorage.removeItem('OpenAi_threadId');
    sessionStorage.removeItem('OpenAi_UploadedFileIds');
    setShowConfirmModal(false);
    window.location.reload();
  };

  const handleSendMessage = async (e) => {
    e.preventDefault();
    if (inputValue.trim() === '') return;

    const userMessage = {
      id: messages.length + 1,
      text: inputValue,
      sender: 'user',
    };

    const newMessages = [...messages, userMessage];
    setMessages(newMessages);
    setInputValue('');
    setIsTyping(true);

    const fileIds = (() => {
      try {
        const ids = JSON.parse(sessionStorage.getItem("OpenAi_UploadedFileIds"));
        return Array.isArray(ids) ? ids : [];
      } catch {
        return [];
      }
    })();

    const attachments = fileIds.map(id => ({
      file_Id: id,
      tools: [
        { type: "code_interpreter" } // ou o tipo que sua API espera
      ]
    }));

    const request = {
      queryType,
      assistantId: aiModel,
      message: {
        role: "user",
        content: inputValue,
      },
      attachments: attachments,
      threadId: sessionStorage.getItem("OpenAi_threadId"),
      database: window.database_type,
      username: localStorage.getItem("RC_USR_PORTAL"),
    };

    try {
      const response = await fetch(`${window.ai_api_service}api/OpenAi/OpenAiAssistantRequest`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(request)
      });

      if (!response.ok) {
        throw new Error(`Erro na API: ${response.status} ${response.statusText}`);
      }

      const data = await response.json();


      if (data && data.message) {
        const aiApiResponse = {
          id: newMessages.length + 1,
          text: data.message, // mantém o Markdown
          sender: 'assistant',
        };
        setMessages(prev => [...prev, aiApiResponse]);

        if (data.file) {
          var meta = {
            fileName: data.file.fileName,
            contentType: data.file.contentType || data.file.contetType
          };
          // usa util para normalizar
          // import { normalizeFileMeta } from '../utils/mime';
          var normalized = window.normalizeFileMeta
            ? window.normalizeFileMeta(meta) // fallback se você injetar global
            : meta; // substitua pela importação correta abaixo
          // (recomendado) use import:
          // import { normalizeFileMeta } from '../utils/mime';
          // var normalized = normalizeFileMeta(meta);

          setFilePayload({
            base64: data.file.base64,
            contentType: normalized.contentType || 'application/octet-stream',
            filename: normalized.fileName || 'arquivo'
          });
          setShowFileModal(true);
        }
      } else {
        console.error("Formato de resposta inesperado", data);
      }

    } catch (error) {
      console.error('Erro ao buscar resposta da IA:', error);
      setMessages(prev => [...prev, {
        id: newMessages.length + 1,
        text: 'Desculpe, não consegui obter uma resposta. Tente novamente.',
        sender: 'assistant',
      }]);
    } finally {
      setIsTyping(false);
    }
  };

  const sendDataToAssistant = async (aiModel, queries = null, isFirstSearch = true) => {
    setLoading(true);
    try {
      const busca = modelConfigurations.find(item => item.assistantId === aiModel);

      console.log(busca);

      const queryType = queries ? queries[1].id : isFirstSearch ? busca.queries[0].id : busca.queries[1].id;

      console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
      console.log(queries);
      console.log(busca);

      const request = {
        queryType,
        startDate,
        endDate,
        threadId: sessionStorage.getItem("OpenAi_threadId"),
        database: window.database_type,
        userName: localStorage.getItem("RC_USR_PORTAL"),
      };

      const response = await fetch(`${window.ai_api_service}api/OpenAi/SendSearchData`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(request)
      });

      if (!response.ok) {
        const errorData = await response.json();

        throw new Error(`Erro na API: ${response.status} - ${errorData.message}`);
      }

      const responseData = await response.json();

      let uploadedIds = [];

      const existingIds = sessionStorage.getItem('OpenAi_UploadedFileIds');
      if (existingIds) {
        try {
          uploadedIds = JSON.parse(existingIds);
          if (!Array.isArray(uploadedIds)) uploadedIds = [];
        } catch {
          uploadedIds = [];
        }
      }
      uploadedIds.push(responseData.fileId);

      sessionStorage.setItem('OpenAi_UploadedFileIds', JSON.stringify(uploadedIds));

      // setToastMessage("Dados enviados para o assistente com sucesso!");
      // setShowToast(true);
      // setShowConfigModal(false);

    } catch (error) {
      console.error('Erro ao enviar os dados para o assistente:', error);
      // setError("Erro ao enviar dados para o assistente! " + error);

    } finally {
      setLoading(false);
    }
  }

  return (
    loading ?
      <Spinner as="span" className='ml-5 mt-3' animation="border" size="lg" role="status" aria-hidden="true" hidden={!loading} />
      :
      <>
        <Sidebar aiModel={aiModel} handleChangeAiModel={handleChangeAiModel} frontConfigs={frontConfigurations} />
        <div className="main-content">
          <div className="chat-window" ref={chatWindowRef}>
            {messages.map((msg) => (
              <div key={msg.id} className={`chat-message ${msg.sender}`}>
                {msg.sender === "assistant" && (
                  <img
                    src={AiAvatar}
                    alt="Avatar da IA"
                    style={{ width: '35px', height: '35px', marginRight: '10px', borderRadius: '50%', verticalAlign: 'top' }}
                  />
                )}

                {/* IA em Markdown, usuário como texto normal */}
                {msg.sender === 'assistant' ? (
                  <AIMessage content={msg.text} />
                ) : (
                  <div>{msg.text}</div>
                )}
              </div>
            ))}

            {isTyping && (
              <div className="chat-message assistant">
                <img
                  src={AiAvatar}
                  alt="Avatar da IA"
                  style={{ width: '35px', height: '35px', marginRight: '10px', borderRadius: '50%', verticalAlign: 'middle' }}
                />
                <div className="typing-indicator">
                  <div></div><div></div><div></div>
                </div>
              </div>
            )}
          </div>

          <div className="chat-input-area">
            <Form onSubmit={handleSendMessage}>
              <FormGroup>
                <div style={{ display: 'flex', gap: '10px', width: '100%' }}>
                  <Button variant="danger" onClick={() => setShowConfirmModal(true)}>
                    <FontAwesomeIcon icon="trash" />
                  </Button>

                  <Button variant="secondary" onClick={() => setShowConfigModal(true)}>
                    <FontAwesomeIcon icon="sliders-h" />
                  </Button>

                  <Button variant="primary" onClick={() => setShowAttachModal(true)}>
                    <FontAwesomeIcon icon="paperclip" />
                  </Button>


                  <div className='input-group'>
                    <Form.Control
                      placeholder={!isTyping ? 'Digite sua mensagem aqui...' : 'Aguarde...'}
                      value={inputValue}
                      onChange={(e) => setInputValue(e.target.value)}
                      disabled={isTyping}
                    />
                    <Button className="btn btn-primary" type="submit" disabled={isTyping}>
                      {isTyping ? 'Aguarde...' : 'Enviar'}
                    </Button>
                  </div>
                </div>
              </FormGroup>
            </Form>
          </div>
        </div>
        <ModalFilters
          isTyping={isTyping}
          queryType={queryType}
          setQueryType={setQueryType}
          setShowConfigModal={setShowConfigModal}
          showConfigModal={showConfigModal}
          startDate={startDate}
          setStartDate={setStartDate}
          availableQueryTypes={availableQueryTypes}
          endDate={endDate}
          setEndDate={setEndDate}
          maxDaysFilter={maxDaysFilter}
        />

        <ModalAttachment
          isTyping={isTyping}
          setShowAttachModal={setShowAttachModal}
          showAttachModal={showAttachModal}
        />

        <ModalClearData
          show={showConfirmModal}
          onClose={() => setShowConfirmModal(false)}
          onConfirm={handleConfirmDelete}
        />

        <ModalFilePreview
          show={showFileModal}
          base64={filePayload ? filePayload.base64 : null}
          contentType={filePayload ? filePayload.contentType : null}
          filename={filePayload ? filePayload.filename : null}
          onHide={function () { setShowFileModal(false); }}
        />
      </>
  );
};

export default MainContent;
